module.exports = __webpack_public_path__ + "img/zitai.cdfad139.png";